import { useState } from "react";
import { PlainTooltip } from "@similarweb/ui-components";
import { ProModal } from "pro-features/components/Modals/src/ProModal";
import { Button } from "@similarweb/ui-components";
import { DropdownButton, CountryDropdownButton } from "@similarweb/ui-components";
import CountriesDropdown from "app/pages/sales-intelligence/sub-modules/advanced-search/components/shared/CountriesDropdown/CountriesDropdown";
import { InfoIcon } from "pro-features/components/BoxTitle/src/BoxTitle";
import type { ICountryObject } from "app/services/CountryService";
import { DD_POPUP_HEIGHT } from "app/pages/sales-intelligence/sub-modules/advanced-search/components/filters/SingleCountryFilter/styles";
import { StyledBaseDropdownButtonWrap } from "app/pages/sales-intelligence/sub-modules/advanced-search/components/common-styles";
import { CUSTOM_MODAL_STYLES, StyledDD, StyledModalSubTitle, StyledWrapperPlainTooltip } from "./styles";
import {
    StyledModalTitle,
    StyledContent,
    StyledFooter,
} from "app/pages/sales-intelligence/pages/manage-export/components/DeleteFieldModal/styles";
import { allTrackers } from "app/services/track/track";
import { translate } from "app/filters/i18nFilter";

type ExportSelectTrafficCountryModalProps = {
    countries: readonly ICountryObject[];
    integration?: string;
    isOpen: boolean;
    onCancel(): void;
    onExport(country: number): void;
};

//FIXME REWORK AND FIND ANOTHER PLACE FOR THIS COMPONENT

const ExportSelectTrafficCountryModal = (props: ExportSelectTrafficCountryModalProps) => {
    const { countries, integration, isOpen, onCancel, onExport } = props;
    const [country, setCountry] = useState<ICountryObject | null>(null);

    const handleSelect = (country: ICountryObject) => setCountry(country);

    const onClickExport = () => {
        if (country !== null) {
            allTrackers.dispatchTrackEvent(
                `${integration} integration`,
                "select single country",
                `export/${integration ?? ""} accounts/${country.id}`,
            );
            onExport(country.id);
        }
    };

    const renderDDButton = () => {
        let button;

        if (country === null) {
            button = (
                <DropdownButton>
                    {translate("si.management.sf.settings_export.modal.traffic_country.selected_btn")}
                </DropdownButton>
            );
        } else {
            button = <CountryDropdownButton countryId={country.id}>{country?.text}</CountryDropdownButton>;
        }

        return <StyledBaseDropdownButtonWrap key="countries-dropdown-button">{button}</StyledBaseDropdownButtonWrap>;
    };

    return (
        <ProModal
            isOpen={isOpen}
            showCloseIcon={false}
            customStyles={CUSTOM_MODAL_STYLES}
        >
            <StyledModalTitle>
                {translate("si.management.sf.settings_export.modal.traffic_country.single.title")}
                &nbsp;
                <StyledWrapperPlainTooltip id="tooltip">
                    <PlainTooltip
                        appendTo={"#tooltip"}
                        placement="top"
                        tooltipContent={translate(
                            "si.management.sf.settings_export.modal.traffic_country.info.tooltip",
                        )}
                    >
                        <div>
                            <InfoIcon iconName="info" />
                        </div>
                    </PlainTooltip>
                </StyledWrapperPlainTooltip>
            </StyledModalTitle>
            <StyledModalSubTitle>
                {translate("si.management.sf.settings_export.modal.traffic_country.subtitle")}
            </StyledModalSubTitle>
            <StyledContent>
                <StyledDD id={"select-traffic-country"}>
                    <CountriesDropdown
                        appendTo={`#select-traffic-country`}
                        onSelect={handleSelect}
                        selectedItems={[`${country?.id || null}`]}
                        items={countries}
                        dropdownPopupHeight={DD_POPUP_HEIGHT}
                        dropdownPopupPlacement="ontop-left"
                        placeholder={translate("si.management.sf.settings_export.modal.traffic_country.placeholder")}
                        renderButton={renderDDButton}
                    />
                </StyledDD>
            </StyledContent>
            <StyledFooter>
                <Button
                    type="flat"
                    onClick={onCancel}
                >
                    {translate("si.management.sf.settings_export.modal.traffic_country.btn.cancel")}
                </Button>
                <Button
                    isDisabled={country === null}
                    type="primary"
                    onClick={onClickExport}
                >
                    {translate("si.management.sf.settings_export.modal.traffic_country.btn.export")}
                </Button>
            </StyledFooter>
        </ProModal>
    );
};

export default ExportSelectTrafficCountryModal;
